module.exports = __webpack_public_path__ + "8a5e32dd513f44778984c179e76976d2.png";